export default __webpack_public_path__ + "fonts/a2121a8cc3c0b6bd77d35252d49a72f1.svg";